var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',_vm._b({directives:[{name:"b-visible",rawName:"v-b-visible",value:(_vm.isVisible),expression:"isVisible"}]},'div',_vm.$attrs,false),[_vm._t("default")],2):_c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }